import { ChangeDetectionStrategy, Component, Inject, type OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { DialogService } from "primeng/dynamicdialog";
import * as FlatFacades from '@medsurf/flat-facades';
import * as FlatModels from '@medsurf/flat-models';
import { Store } from '@ngxs/store';
import { AuthControlService, FLAT_SETTINGS, type SettingControlModel } from '@medsurf/flat-services';

@Component({
    selector: 'medsurf-login',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  readonly FlatModels = FlatModels;
  
  
  constructor(public authControlFacade: FlatFacades.AuthControlFacade,
              public authControlService: AuthControlService,
              public router: Router,
              public store: Store,
              public dialogService: DialogService,
              @Inject(FLAT_SETTINGS) public settings: SettingControlModel) {

    this.authControlFacade.canAccessAuthor$.pipe(takeUntilDestroyed()).subscribe((canAccessAuthor) => {
      if (canAccessAuthor) {
        this.goToAuthor();
      }
    });
  }

  async ngOnInit() {
    // Close All Open Dialogs
    this.dialogService.dialogComponentRefMap.forEach(dialog => {
      dialog.destroy();
    });
  }

  goToViewer() {
    window.open(this.settings.viewerUrl, '_self');
  }

  goToAuthor() {
    const redirectRoute = this.authControlService.getRedirectRoute();
    this.router.navigate(redirectRoute);
  }

  login() {
    this.authControlService.oidcAuthLogin();
  }
  
  logout() {
    this.authControlService.oidcAuthLogout();
  }
  
}
